export const roundFloat = (amount: number) => Math.round(amount * 100) / 100
